import FacebookAdsCards from '../../components/Facebook/Ads/FacebookAdsCards';
import ListingPage from '../../components/ListingPage';

const FacebookAdsPage = () => {
  return <ListingPage entityType="facebookAd" useStats={true} filterBy="name" Cards={FacebookAdsCards} />;
};

export default FacebookAdsPage;
